"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_FORGOT_PASSWORD_EMAIL = exports.FORGOT_PASSWORD_CLICKED = exports.LOGIN_CLICKED = exports.SELECTED_TENANT = exports.FOUND_TENANTS = exports.SUBMIT_EMAIL = exports.UPDATE_PASSWORD = exports.UPDATE_EMAIL = void 0;
// State constants for widgets
var UPDATE_EMAIL = 'UPDATE_EMAIL';
exports.UPDATE_EMAIL = UPDATE_EMAIL;
var UPDATE_PASSWORD = 'UPDATE_PASSWORD';
exports.UPDATE_PASSWORD = UPDATE_PASSWORD;
var SUBMIT_EMAIL = 'SUBMIT_EMAIL';
exports.SUBMIT_EMAIL = SUBMIT_EMAIL;
var FOUND_TENANTS = 'FOUND_TENANTS';
exports.FOUND_TENANTS = FOUND_TENANTS;
var SELECTED_TENANT = 'SELECTED_TENANT';
exports.SELECTED_TENANT = SELECTED_TENANT;
var LOGIN_CLICKED = 'LOGIN_CLICKED';
exports.LOGIN_CLICKED = LOGIN_CLICKED;
var FORGOT_PASSWORD_CLICKED = 'FORGOT_PASSWORD_CLICKED';
exports.FORGOT_PASSWORD_CLICKED = FORGOT_PASSWORD_CLICKED;
var UPDATE_FORGOT_PASSWORD_EMAIL = 'UPDATE_FORGOT_PASSWORD_EMAIL';
exports.UPDATE_FORGOT_PASSWORD_EMAIL = UPDATE_FORGOT_PASSWORD_EMAIL;